import LoginRoutes from "../Modules/User/Routes/LoginRoutes";
import GymRoutes from "../Modules/Gym/Routes/PublicRoutes";

const PublicRoutes = () => {
  return (
    <>
      <LoginRoutes />
      <GymRoutes />
    </>
  );
};

export default PublicRoutes;
